import { OfferFormState } from '../../../store/offer-store';
import type { IRowData } from '../Components/OfferTable/OfferTable';
import type { ProdutoDetalhado } from '../hooks/useProdutosCampanha';
import { buildInitialProductFromOfferRow } from './buildInitialProductFromOfferRow';

const OFFER_FORM_FIELDS: ReadonlyArray<keyof Omit<OfferFormState, 'offer_type'>> = [
  'offer_price',
  'percentage_discount',
  'from',
  'to',
  'buy_quantity',
  'pay_quantity',
  'unit_buy',
  'minimum_quantity',
  'price_per_unit',
];

function allEqual<T>(arr: T[]): boolean {
  if (arr.length === 0) return true;
  return arr.every(v => v === arr[0]);
}

export function computeBulkInitialValues(offers: IRowData[]): {
  initialOffer: OfferFormState | null;
  initialOfferGroup: string | null;
  initialProducts: Pick<
    ProdutoDetalhado,
    | 'product_id'
    | 'product_uuid'
    | 'description'
    | 'pmz'
    | 'retail_price'
    | 'retail_price_cpi'
    | 'avg_competitiveness_price'
    | 'offer_price_cpi'
    | 'margin'
  >[];
} {
  if (offers.length === 0) {
    return { initialOffer: null, initialOfferGroup: null, initialProducts: [] };
  }

  const offerTypes = offers.map(o => o.offer_dto?.offer?.offer_type ?? null);
  const offerType = allEqual(offerTypes) ? offerTypes[0] : null;

  const offerGroups = offers.map(o => o.offer_group ?? null);
  const initialOfferGroup = allEqual(offerGroups) ? offerGroups[0] : null;

  let initialOffer: OfferFormState | null = null;
  if (offerType) {
    const fieldValues: Partial<OfferFormState> = {};
    OFFER_FORM_FIELDS.forEach(field => {
      const values = offers.map(o => (o.offer_dto?.offer as unknown as Record<string, unknown>)?.[field] ?? null);
      (fieldValues as Record<string, unknown>)[field] = allEqual(values) ? values[0] : null;
    });
    initialOffer = { offer_type: offerType, ...fieldValues };
  }

  const initialProducts = offers.map(o => ({
    ...buildInitialProductFromOfferRow(o),
  }));

  return { initialOffer, initialOfferGroup, initialProducts };
}
